import axios from 'axios'
import store from '@/store'
import router from '@/router'
import { getToken, removeToken } from '@/utils/auth'
import { environment } from '../environment'
import Cookies from 'js-cookie'
import i18n from '../i18n/i18n'


const service = axios.create({
  baseURL: environment.baseURL, // base api url
  timeout: 50000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    if (store.getters.token) {
      config.headers['Authorization'] = 'Bearer ' + getToken()
      config.headers['X-LANG'] = i18n.locale
    }
    return config
  },
  error => {
    Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  response => {
   const data = response.data
    switch (data.status) {
      case 'success':
        return Promise.resolve(response)
      case 'failed':
        return Promise.reject(data.message)
      default:
        if (response.status === 200) {
          return Promise.resolve(response)
        } else {
          return Promise.reject('Server error, please try again.')
        }
    }
    // return response
  },
  error => {
    if(error.response && error.response.status) {
      if(error.response.status === 401) {
        const cu = store.getters.currentUser
        if(cu){
          router.push({name:cu.user_role=='user'?'user_login':'page-login'});
          removeToken();
          Cookies.remove('currentUser');
        }
        return Promise.reject('Session timeout, please login to continue...');
      }
    }
    return Promise.reject(error.message)
  }
)

export default service
